/**
 * Service Worker registration helper.
 * Called once from src/index.js (or App). Safe to call multiple times.
 */
export const registerServiceWorker = () => {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Avoid registering during local hot-reload sessions where SW interferes
  // with Webpack dev server. Only register on production builds OR when
  // hostname is not localhost.
  const isLocalhost = ["localhost", "127.0.0.1"].includes(
    window.location.hostname
  );
  if (process.env.NODE_ENV !== "production" && isLocalhost) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Optional: listen for updates
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              // New SW installed; activate immediately on next nav
              sw.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        // Silent fail — PWA install just won't work
      });
  });
};
